<script>
// Services
import UsersDataService from "@/services/UsersDataService"
import MediaDataService from "@/services/MediaDataService"
import AuthService from "@/services/AuthService";
import AnnotationsService from "@/services/AnnotationsService";
import ScoreService from "@/services/ScoreService";

// Helpers
import Storage from "@/helpers/storage"
import CompareUtils from "@/helpers/compare"
import UserUtils from '@/helpers/users'
import AdminUtils from '@/helpers/admin'
import DateUtils from '@/helpers/date';
import { Role, getRole } from '@/helpers/role'
import {authComputed} from "@/state/helpers";

// External Components
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css';

// Libs
import isEmpty from "is-empty";

let previousInterests = null;
let previousLifeStyle = null;
let previousInterestsSelected = null;
let previousLifeStyleSelected = null;
let previousAlertE = null;
let previousAlertP = null;
let previousAlertESelected = [];
let previousAlertPSelected = [];

export default {
  name: "UserProfile",
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Multiselect,
    DatePicker,
  },

  methods: {
    ...UserUtils,
    ...DateUtils,

    initUser() {
      if (this.getUserRole === Role.MarketingGuest) {
        return;
      }

      this.resetPublicInfo();
      this.resetPrivateInfo();
      this.loadMedia();
      this.loadSocial();
      this.loadDescription();
      this.loadNotifications();
      this.loadTokens();
      this.loadSubscriptions();
      this.loadCreditsActions();
      this.loadPayments();
      this.loadUserPacks();
      this.loadQriHistory();
      this.isUserInit = true;
    },

    loadMedia() {
      this.isLoadingMedia = true;
      UsersDataService.getMedia(this.user.userId)
      .then(response => {
        const media = response.data;
        const l = media.length;
        if (l > 0) {
          media.forEach(m => {
            m.src = '';
            m.title = m.rankMedia + "/" +l;
            this.media.push(m);
            this._loadMedia(m);
          });
        }
        this.isLoadingMedia = false;
      })
      .catch(error => {
        this.isLoadingMedia = false;
        window.console.error(error);
        this.$toast.error(this.$t("global_error"));
      });
    },

    _loadMedia(m) {
      let mid, thumbId;
      if (m.typeMedia === 0) {
        if (m.isValid) {
          mid = m.mediaId;
          thumbId = m.thumbFileName;
        }
        else {
          mid = m.mediaId + ".origin";
          thumbId = m.thumbFileName + ".origin";
        }
      }
      else {
        mid = m.mediaId;
        thumbId = m.thumbFileName;
      }

      Storage.getUserMediaUrl(m.userId, mid).then((imageUrl) => {
        m.src = imageUrl;
        if (m.rankMedia === 1 && m.typeMedia === 0)
          this.mainMedia = imageUrl;
      });

      Storage.getUserMediaUrl(m.userId, thumbId).then((imageUrl) => {
        m.srcThumb = imageUrl;
        if (m.rankMedia === 1 && m.typeMedia === 0) {
          this.user.photo = thumbId;
          const elt = document.getElementById(m.userId+'-img');
          if (elt) {
            if (elt.tagName === 'IMG')
              elt.setAttribute('src', imageUrl);
            else
              elt.style.backgroundImage = "url(" + imageUrl + ")";
          }
        }
        else if (m.rankMedia === 1 && m.typeMedia === 1) {
          this.user.video = thumbId;
          const elt = document.getElementById(m.userId+'-video');
          if (elt) {
            if (elt.tagName === 'IMG')
              elt.setAttribute('src', imageUrl);
            else
              elt.style.backgroundImage = "url(" + imageUrl + ")";
          }
        }
      })
    },

    showMedia(mediaId) {
      const activeMediaIndex = this.media.findIndex(x => x.mediaId === mediaId);
      this.$emit("SHOW_MEDIA", this.media, activeMediaIndex);
    },

    loadDescription() {
      if (this.user.description === null)
        this.user.description = '';

      this.description = this.user.description;
      UsersDataService.getDescription(this.user.userId)
        .then(response => {
          previousLifeStyle = response.data.lifestyle;
          previousLifeStyleSelected = response.data.lifestyleSelected;
          previousInterests = response.data.interests;
          previousInterestsSelected = response.data.interestsSelected;
          this._createLifeStyle();
          this._createInterests();
          this.isDescriptionInit = true;
        })
        .catch(error => {
          window.console.error("UsersDataService.getDescription ERROR", error);
        });
    },

    _createLifeStyle() {
      this.lifeStyle = [];
      previousLifeStyle.forEach(lifeStyleCategory => {
        let cat = {
          id: lifeStyleCategory.id,
          selected: lifeStyleCategory.selected === null ? '' : lifeStyleCategory.selected,
          items: []
        };
        lifeStyleCategory.items.forEach(item => {
          cat.items.push(Object.assign({}, item));
        });
        this.lifeStyle.push(cat);
      });
      this.lifeStyleSelected = Array.from(previousLifeStyleSelected);
    },

    _createInterests() {
      this.interests = [];
      previousInterests.forEach(interestsCategory => {
        let cat = {
          id: interestsCategory.id,
          color: interestsCategory.color,
          items: []
        };
        interestsCategory.items.forEach(item => {
          cat.items.push(Object.assign({}, item));
        });
        this.interests.push(cat);
      });
      this.interestsSelected = Array.from(previousInterestsSelected);
    },

    loadSubscriptions() {
      UsersDataService.getSubscriptions(this.user.userId)
        .then(response => {
          const { subscriptions } = response.data;
          this.subscriptionsList = subscriptions;
        })
        .catch(error => {
          window.console.error("UsersDataService.getSubscriptions ERROR", error);
          this.$toast.error(error.message);
        });
    },

    cancelUserPack(pack) {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }

      this.isUpdating = true;
      return UserUtils.cancelUserPack(this.user.userId, pack)
          .then(async () => {
            pack.status = "C";
            pack.canceledAt = DateUtils.formatDateTimestamp(DateUtils.now()/1000, "YYYY-MM-DD HH:mm:ss");
            if (pack.packType === "B" && this.user.boostsReloadId === pack.packId) {
              this.user.boostsReloadId = null;
            }
            else if (pack.packType === "IB"  && this.user.iceBreakersReloadId === pack.packId) {
              this.user.iceBreakersReloadId = null;
            }

            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'user',
              type: 'pack-cancel',
              userId: this.user.userId,
              data1: JSON.stringify(pack)
            });
            this.isUpdating = false;
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("cancelUserPack", error);
            this.$toast.error(error.message);
          });
    },

    removePremium() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      return UserUtils.removePremium(this.user.userId)
          .then(async () => {
            this.user.isSubscribed = 0;
            this.user.hasLifeTimeEnabled = 0;
            this.user.hasLifeTimeStartedAt = null;

            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'user',
              type: 'remove-premium',
              userId: this.user.userId,
              data1: null
            });
            this.isUpdating = false;
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("removePremium", error);
            this.$toast.error(error.message);
          });
    },

    cancelSubscription(subscription) {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }

      if (subscription.status === 'S') {
        return this.deleteSubscription(subscription);
      }
      this.isUpdating = true;
      return UserUtils.cancelSubscription(subscription)
          .then(async () => {
            subscription.status = "C";
            subscription.canceledAt = DateUtils.formatDateTimestamp(DateUtils.now()/1000, "YYYY-MM-DD HH:mm:ss");

            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'user',
              type: 'subscription-cancel',
              userId: this.user.userId,
              data1: JSON.stringify(subscription)
            });
            this.isUpdating = false;
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("cancelSubscription", error);
            this.$toast.error(error.message);
          });
    },

    deleteSubscription(subscription) {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }

      this.isUpdating = true;
      return UserUtils.deleteSubscription(this.user.userId, subscription)
          .then(async () => {
            subscription.status = "C";
            subscription.canceledAt = DateUtils.formatDateTimestamp(DateUtils.now()/1000, "YYYY-MM-DD HH:mm:ss");
            this.user.isSubscribed = 0;
            this.user.subscriptionId = null;

            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'user',
              type: 'subscription-delete',
              userId: this.user.userId,
              data1: JSON.stringify(subscription)
            });
            this.isUpdating = false;
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("deleteSubscription", error);
            this.$toast.error(error.message);
          });
    },

    loadUserPacks() {
      UsersDataService.getUserPacks(this.user.userId)
          .then(response => {
            const { packs } = response.data;
            this.userPacks = packs;
          })
          .catch(error => {
            window.console.error("UsersDataService.getUserPacks ERROR", error);
            this.$toast.error(error.message);
          });
    },

    loadPayments() {
      UsersDataService.getPayments(this.user.userId)
          .then(response => {
            const { payments } = response.data;
            this.paymentsList = payments;
          })
          .catch(error => {
            window.console.error("UsersDataService.getPayments ERROR", error);
            this.$toast.error(error.message);
          });
    },

    loadQriHistory() {
      const params = {
        userId: this.user.userId,
      };

      if (this.filtersQri.dates.selected === 'custom' && this.filtersQri.dates.dateRange !== null) {
        this.filtersQri.fromDate = this.$moment(this.filtersQri.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersQri.toDate = this.$moment(this.filtersQri.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersQri.fromDate === null)
        this.handleQriDateChange();

      if (this.filtersQri.toDate !== null)
        params['toDate'] = this.filtersQri.toDate;

      if (this.filtersQri.fromDate !== null)
        params['fromDate'] = this.filtersQri.fromDate;

      this.isLoadingQri = true;
      ScoreService.getUserHistory(params)
          .then(response => {
            this.isLoadingQri = false;
            const { stats, history } = response.data;
            this.qriStats = stats;

            this.$refs.scoreChart.updateSeries([
              {
                name: "QRI",
                type: 'line',
                data: history
              }
            ]);
          })
          .catch(error => {
            this.isLoadingQri = false;
            window.console.error("ScoreService.getUserHistory ERROR", error);
            this.$toast.error(error.message);
          });
    },

    loadCreditsActions() {
      UsersDataService.getCreditsActions(this.user.userId)
          .then(response => {
            const { actions } = response.data;
            this.actionsList = actions;
            this.getActionsMediaThumb();
          })
          .catch(error => {
            window.console.error("UsersDataService.getCreditsActions ERROR", error);
            this.$toast.error(error.message);
          });
    },

    loadSocial() {

    },

    loadNotifications() {
      UsersDataService.getNotifications(this.user.userId)
        .then(response => {
          const alerts = response.data.results;
          previousAlertE = alerts.E;
          previousAlertP = alerts.P;
          this._createNotifications();
        })
        .catch(error => {
          window.console.error("UsersDataService.getNotifications ERROR", error);
        });
    },

    _createNotifications() {
      this.alertsE = [];
      this.alertsP = [];

      previousAlertE.forEach(alert => {
        let item = {
          alertId: alert.alertId,
          selected: alert.selected === 1,
          typeAlert: alert.typeAlert
        };
        if (item.selected)
          previousAlertESelected.push(alert.alertId);

        this.alertsE.push(item);
      });
      this.alertsESelected = Array.from(previousAlertESelected);

      previousAlertP.forEach(alert => {
        let item = {
          alertId: alert.alertId,
          selected: alert.selected === 1,
          typeAlert: alert.typeAlert
        };
        if (item.selected)
          previousAlertPSelected.push(alert.alertId);

        this.alertsP.push(item);
      });
      this.alertsPSelected = Array.from(previousAlertPSelected);
    },

    loadTokens() {
      UsersDataService.getTokens(this.user.userId).
      then(response => {
        const tokens = response.data.results;
        const l = tokens.length;
        if (l > 0)
          this.tokens = tokens;
      })
      .catch(error => {
        window.console.error("UsersDataService.getTokens ERROR", error);
      });
    },

    onChangeSex (value) {
      this.publicInfo.sex = value.value ? 1 : 2;
    },

    onChangeCountry (value) {
      if (!isEmpty(value.alpha2))
        this.publicInfo.country = value.alpha2;
    },

    onChangeMinAge(value) {
      this.publicInfo.minAge = Number.parseInt(value);
    },

    onChangeMaxAge(value) {
      this.publicInfo.maxAge = Number.parseInt(value);
    },

    onChangeDistance(value) {
      this.publicInfo.distance = Number.parseInt(value);
    },

    arraysContainSame(a, b) {
      a = Array.isArray(a) ? a : [];
      b = Array.isArray(b) ? b : [];
      return a.length === b.length && a.every(el => b.includes(el));
    },

    resetPublicInfo() {
      this.publicInfo.name = this.user.name;
      this.publicInfo.birth = this.user.birth;
      this.publicInfo.sex = this.user.sex;
      this.publicInfo.search = this.user.search;
      this.publicInfo.searchType = this.user.searchType;
      this.publicInfo.minAge = this.user.minAge;
      this.publicInfo.maxAge = this.user.maxAge;
      this.publicInfo.distance = this.user.searchDistance;
      this.publicInfo.country = this.user.country;
      this.publicInfo.locality = this.user.locality;
      let selectedCountry = this.publicInfo.countries.options.find(x => x.alpha2 === this.user.country.toLowerCase());
      if (!isEmpty(selectedCountry)) {
        this.publicInfo.countries.selected = selectedCountry;
      }
    },

    savePublicInfo() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      const errors = [];
      this.publicInfo.name = this.publicInfo.name.trim();
      if (this.publicInfo.name === '')
        errors.push(this.$t("user.error_empty_name"));

      if (UserUtils.getAge(this.publicInfo.birth) < 18)
        errors.push(this.$t("user.error_invalid_age"));

      this.publicInfo.locality = this.publicInfo.locality.trim();
      if (this.publicInfo.locality === '')
        errors.push(this.$t("user.error_empty_locality"));

      let minAge = parseInt(this.publicInfo.minAge),
          maxAge = parseInt(this.publicInfo.maxAge);
      if (minAge < 18 || maxAge < 19 || minAge > maxAge || minAge > 99 || maxAge > 100)
        errors.push(this.$t("user.error_invalid_age_search"));

      if (this.publicInfo.distance > 1000 || this.publicInfo.distance < 0)
        errors.push(this.$t("user.error_invalid_distance"));

      if (this.publicInfo.search.length === 0)
        errors.push(this.$t("user.error_invalid_search"));

      if (this.publicInfo.searchType.length === 0)
        errors.push(this.$t("user.error_invalid_searchType"));

      if (errors.length > 0) {
        this.$toast.error(this.$t("user.error_update_global") + errors.join("<br>"));
        this.isUpdating = false;
        return;
      }

      const data = {
        name: this.publicInfo.name,
        birth: this.publicInfo.birth,
        searchDistance: this.publicInfo.distance,
        minAge: this.publicInfo.minAge,
        maxAge: this.publicInfo.maxAge,
        sex: this.publicInfo.sex,
        search: this.publicInfo.search,
        searchType: this.publicInfo.searchType,
        locality: this.publicInfo.locality,
        country: this.publicInfo.country,
      };

      return UserUtils.savePublicInfo(this.user.userId, data)
        .then(async () => {
          await AdminUtils.addAction({
            adminId: this.getUser.uid,
            category: 'user',
            type: 'update-public',
            userId: this.user.userId,
            data1: JSON.stringify(data)
          });

          if (this.publicInfo.sex !== this.user.sex) {
            await UsersDataService.updateMarketing(this.user.userId, {
              sex: this.publicInfo.sex
            });
          }

          this.user.name = this.publicInfo.name;
          this.user.birth = this.publicInfo.birth;
          this.user.sex = this.publicInfo.sex;
          this.user.search = this.publicInfo.search;
          this.user.searchType = this.publicInfo.searchType;
          this.user.minAge = this.publicInfo.minAge;
          this.user.maxAge = this.publicInfo.maxAge;
          this.user.searchDistance = this.publicInfo.distance;
          this.user.country = this.publicInfo.country;
          this.user.locality = this.publicInfo.locality;
          this.isUpdating = false;
          this.changePublicInfo = false;
          this.$toast.success(this.$t("user.success_update"));


        })
        .catch(error => {
          this.isUpdating = false;
          window.console.error("savePublicInfo", error);
          this.$toast.error(error.message);
        });
    },

    resetPrivateInfo() {
      this.privateInfo.email = this.user.email;
      if (!isEmpty(this.user.phone)) {
        this.phoneNumber = this.user.phone
      }
      else {
        this.phoneNumber = "";
        this.phoneDetails = null;
      }

      this.changePrivateInfo = false;
    },

    async savePrivateInfo() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      const errors = [];
      this.privateInfo.email = this.privateInfo.email.trim();
      if (this.privateInfo.email === '')
        errors.push(this.$t("user.error_empty_email"));

      this.privateInfo.phone = this.privateInfo.phone.trim();
      if (this.privateInfo.phone === '')
        errors.push(this.$t("user.error_empty_phone"));
      else if (!UserUtils.isPhoneValid(this.privateInfo.phone))
        errors.push(this.$t("user.error_invalid_phone"));

      if (errors.length > 0) {
        this.$toast.error(this.$t("user.error_update_global") + errors.join("<br>"));
        this.isUpdating = false;
        return;
      }

      const data = {
        email: this.privateInfo.email,
        phone: this.privateInfo.phone,
      };

      if (this.privateInfo.email !== this.user.email) {
        try {
          await AuthService.updateEmail(this.user.userId, data.email);
        }
        catch (error) {
          this.isUpdating = false;
          window.console.error("updateEmail", error);
          this.$toast.error(error.message);
          return;
        }
      }

      if (data.phone !== this.user.phone) {
        try {
          await AuthService.updatePhone(this.user.userId, data.phone);
        }
        catch (error) {
          this.isUpdating = false;
          window.console.error("updatePhone", error);
          this.$toast.error(error.message);
          return;
        }
      }

      return UserUtils.savePrivateInfo(this.user.userId, data)
          .then(async () => {
            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'user',
              type: 'update-private',
              userId: this.user.userId,
              data1: JSON.stringify(data)
            });
            this.user.email = this.privateInfo.email;
            this.user.phone = this.privateInfo.phone;
            this.isUpdating = false;
            this.changePrivateInfo = false;
            this.$toast.success(this.$t("user.success_update"));
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("savePrivateInfo", error);
            this.$toast.error(error.message);
          });
    },

    saveDescription() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      this.description = this.description.trim();
      return UserUtils.saveDescription(this.user.userId, this.description)
        .then(async () => {
          await AdminUtils.addAction({
            adminId: this.getUser.uid,
            category: 'user',
            type: 'update-description',
            userId: this.user.userId,
            data1: this.description
          });
          this.user.description = this.description;
          this.changeDescription = false;
          this.isUpdating = false;
          this.$toast.success(this.$t("user.success_update"));
        })
        .catch(error => {
          this.isUpdating = false;
          window.console.error("saveDescription", error);
          this.$toast.error(error.message);
        });
    },

    resetDescription() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.description = this.user.description;
      this.changeDescription = false;
    },

    saveLifeStyle() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      return UserUtils.saveLifeStyle(this.user.userId, this.lifeStyleSelected)
          .then(async () => {
            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'user',
              type: 'update-lifestyle',
              userId: this.user.userId,
              data1: this.lifeStyleSelected.join(",")
            });
            previousLifeStyleSelected = this.lifeStyleSelected;
            this.changeLifestyle = false;
            this.isUpdating = false;
            this.$toast.success(this.$t("user.success_update"));
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("saveLifeStyle", error);
            this.$toast.error(error.message);
          });
    },

    resetLifeStyle() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this._createLifeStyle();
      this.changeLifestyle = false;
    },

    saveInterests() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      const its = [];
      this.interestsSelected.forEach(elt => {
        its.push(elt.text);
      });

      return UserUtils.saveInterests(this.user.userId, its)
          .then(async () => {
            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'user',
              type: 'update-interests',
              userId: this.user.userId,
              data1: its.join(",")
            });
            previousInterestsSelected = this.interestsSelected;
            this.changeInterests = false;
            this.isUpdating = false;
            this.$toast.success(this.$t("user.success_update"));
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("saveInterests", error);
            this.$toast.error(error.message);
          })
    },

    resetInterests() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this._createInterests();
      this.changeInterests = false;
    },

    handleLifestyleValue(categoryId, value) {
      let found = false;
      this.lifeStyleSelected.forEach((lifestyle, index) => {
        if (lifestyle.substr(0, 3) === categoryId+'_') {
          found = true;
          if (value === '')
            this.lifeStyleSelected.splice(index, 1);
          else
            this.lifeStyleSelected[index] = value;

        }
      });
      if (!found)
        this.lifeStyleSelected.push(value);

      this.changeLifestyle = CompareUtils.arraySimpleIsDifferent(this.lifeStyleSelected, previousLifeStyleSelected);
    },

    handleInterestValue(categoryId, value, color) {
      const interest = {category: categoryId, text: value, color: color};
      const index = this.interestsSelected.findIndex(interest => interest.text === value);
      const selected = index === -1;
      if (!selected)
        this.interestsSelected.splice(index, 1);
      else
        this.interestsSelected.push(interest);

      let interestedIndex = this.interests.findIndex(i => i.id === categoryId);
      let itemIndex = this.interests[interestedIndex].items.findIndex(i => i.text === value);
      this.interests[interestedIndex].items[itemIndex].selected = selected;
      this.changeInterests = CompareUtils.arraySimpleObjectIsDifferent(this.interestsSelected, previousInterestsSelected);
    },

    handleAlertValue(alertId, typeAlert, event) {
      let idx;
      if (typeAlert === 'P') {
        idx = this.alertsPSelected.indexOf(alertId);
        if (event.value && idx === -1) {
          this.alertsPSelected.push(alertId);
        }
        else if (!event.value && idx > -1) {
          this.alertsPSelected.splice(idx, 1);
        }
      }
      else if (typeAlert === 'E') {
        idx = this.alertsESelected.indexOf(alertId);
        if (event.value && idx === -1) {
          this.alertsESelected.push(alertId);
        }
        else if (!event.value && idx > -1) {
          this.alertsESelected.splice(idx, 1);
        }
      }

      if (CompareUtils.arraySimpleIsDifferent(this.alertsPSelected, previousAlertPSelected))
        this.changeAlerts = true;
      else if (CompareUtils.arraySimpleIsDifferent(this.alertsESelected, previousAlertESelected))
        this.changeAlerts = true;
      else
        this.changeAlerts = false;
    },

    setMediaAsMain(media) {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      UserUtils.setMediaAsMain(this.user.userId, media)
          .then(async () => {
            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'media',
              type: 'setMain',
              userId: this.user.userId,
              data1: media.mediaId
            });
            this.$toast.success(this.$t("user.media_delete_success"));
            this.mainMedia = null;
            this.media = [];
            this.isLoadingMedia = true;
            setTimeout(this.loadMedia, 10000);
          })
          .catch(error => {
            window.console.error("setMediaAsMain", error);
            this.$toast.error(error.message);
          });
    },

    deleteMedia(media) {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      const msg = String(this.$t("user.confirm_media_delete")).replace('{rank}', media.rankMedia).replace('{id}', media.mediaId);
      this.$bvModal.msgBoxConfirm(msg,  {
        title: this.$t('confirm_title'),
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('confirm'),
        cancelTitle: this.$t('cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(async (value) => {
        if (value) {
          await MediaDataService.archiveMedia({
            userId: this.user.userId,
            mediaId: media.mediaId,
            adminId: this.getUser.uid,
          });

          UserUtils.deleteMedia(this.user.userId, media)
              .then(async () => {
                await AdminUtils.addAction({
                  adminId: this.getUser.uid,
                  category: 'media',
                  type: 'delete',
                  userId: this.user.userId,
                  data1: media.mediaId
                });
                this.$toast.success(this.$t("user.media_delete_success"));
                if (media.rankMedia === 1 && media.typeMedia === 0) {
                  this.mainMedia = null;
                  this.media = [];
                  this.isLoadingMedia = true;
                  setTimeout(this.loadMedia, 10000);
                }
                else if (media.rankMedia === 1 && media.typeMedia === 1) {
                  this.media = [];
                  this.isLoadingMedia = true;
                  setTimeout(this.loadMedia, 10000);
                }
                else {
                  const mediaIndex = this.media.findIndex(x => x.mediaId === media.mediaId);
                  if (mediaIndex > -1) {
                    this.media.splice(mediaIndex, 1);
                  }
                }
              })
              .catch(error => {
                window.console.error("deleteMedia", error);
                this.$toast.error(error.message);
              });
        }
      });
    },

    deleteToken(token) {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      const msg = String(this.$t("user.confirm_token_delete")).replace('{token}', token);
      this.$bvModal.msgBoxConfirm(msg,  {
        title: this.$t('confirm_title'),
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('confirm'),
        cancelTitle: this.$t('cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          UserUtils.deleteToken(this.user.userId, token)
            .then(async () => {
              await AdminUtils.addAction({
                adminId: this.getUser.uid,
                category: 'user',
                type: 'delete-token',
                userId: this.user.userId,
                data1: token
              });
              this.$toast.success(this.$t("user.token_delete_success"));
            })
            .catch(error => {
              window.console.error("deleteToken", error);
              this.$toast.error(error.message);
            });
        }
      });
    },

    disableUser() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      return UserUtils
        .disableUser(this.user.userId, this.getUser.uid)
        .then(() => {
          this.isUpdating = false;
          this.user.disabled = 1;
          this.$toast.success(this.$t('disable_success'));
        })
        .catch(error => {
          let errorMsg = error.message;
          if (errorMsg === "subscription") {
            errorMsg = this.$t("user.active_subscription");
          }
          this.isUpdating = false;
          window.console.error("disableUser", error);
          this.$toast.error(errorMsg);
        });
    },

    enableUser() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      return UserUtils
          .enableUser(this.user.userId, this.getUser.uid)
          .then(() => {
            this.isUpdating = false;
            this.user.disabled = 0;
            this.$toast.success(this.$t('enable_success'));
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("enableUser", error);
            this.$toast.error(error.message);
          });
    },

    checkedUser() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      const params = {
        adminId: this.getUser.uid
      };
      return UserUtils
          .checkedUser(this.user.userId, params)
          .then(() => {
            this.user.checked = '1';
            this.isUpdating = false;
            this.$toast.success(this.$t('checked_success'));
            this.$emit("USER_VERIFIED", this.user);
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("checkedUser", error);
            this.$toast.error(error.message);
          });
    },

    confirmDeleteUser() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      const h = this.$createElement;
      const userImg = document.getElementById(`user-img-${this.user.userId}`).style.backgroundImage;
      const messageVNode = h('div', {
        class:'text-center'
      }, [
        h('span', {
          class: "d-inline-block rounded-circle avatar-sm",
          style: {
            backgroundImage: userImg,
            verticalAlign: 'middle'
          }
        }),
        h('span', {
          class: "d-inline-block text-muted m-2",
          style: {
            verticalAlign: 'middle'
          },
          domProps: {
            innerHTML: this.$t("users.confirm_delete", {name: this.user.name})
          }
        })
      ]);

      this.$bvModal.msgBoxConfirm([messageVNode],  {
        title: this.$t('confirm_title'),
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('confirm'),
        cancelTitle: this.$t('cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.isUpdating = true;
          UserUtils
              .deleteUser(this.user.userId, this.getUser.uid)
              .then(() => {
                this.$toast.success(this.$t("user.delete_success"));
                this.isUpdating = false;
                this.$emit("DELETE_USER", this.user.userId);
              })
              .catch(error => {
                let errorMsg = error.message;
                if (errorMsg === "subscription") {
                  errorMsg = this.$t("user.active_subscription");
                }
                this.$toast.error(errorMsg);
                window.console.error(error);
                this.isUpdating = false;
              });
        }
      });
    },

    blockPhone() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      return UserUtils
          .blockPhone(this.user.userId, this.user.phone)
          .then(async () => {
            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'block',
              type: 'phone',
              userId: this.user.userId,
              data1: this.user.phone
            });
            this.isUpdating = false;
            this.$toast.success(this.$t('block_phone_success'));
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("blockPhone", error);
            this.$toast.error(error.message);
          });
    },

    blockIP() {
      this.$toast.warning("blockIP not implemented");
    },

    loadAnnotations() {
      return AnnotationsService
              .getList(this.user.userId)
              .then(response => {
                const { items } = response.data;
                this.annotationsList = items;
              })
              .catch(error => {
                window.console.error("loadAnnotations", error);
                this.$toast.error(error.message);
              });
    },

    addAnnotation() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      const message = this.annotation.trim();
      if (message.length === 0) {
        this.$toast.error(this.$t('annotation_empty'));
        return;
      }
      const params = {
        adminId: this.getUser.uid,
        message: message
      };
      this.isUpdating = true;
      return AnnotationsService
          .saveAnnotation(this.user.userId, params)
          .then(response => {
            this.isUpdating = false;
            this.annotation = '';
            const newAnnotation = response.data.item;
            this.annotationsList.unshift(newAnnotation);
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("addAnnotation", error);
            this.$toast.error(error.message);
          });
    },

    saveAlerts() {
      if (this.getUserRole === Role.MarketingGuest) {
        this.$toast.error("Unauthorized Section");
        return;
      }
      this.isUpdating = true;
      const alerts = this.alertsPSelected.concat(this.alertsESelected);
      UserUtils.updateAlerts(this.user.userId, alerts)
          .then(async () => {
            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'user',
              type: 'update-alerts',
              userId: this.user.userId,
              data1: alerts
            });
            this.isUpdating = false;
            this.changeAlerts = false;
            this.$toast.success(this.$t("user.alerts_update_success"));
          })
          .catch(error => {
            this.isUpdating = false;
            window.console.error("saveAlerts", error);
            this.$toast.error(error.message);
          });
    },

    handlePedigreePage(value) {
      this.pedigreePage = value;
      this.pedigree = [];
      this.generatePedigree();
    },

    handleActionsPage(value) {
      this.actionsPage = value;
      this.actions = [];
      this.generateActions();
    },

    handlePedigreeEvent(eventName) {
      this.filtersPedigree.eventName = eventName;
      this.pedigreePage = 1;
      this.pedigreeCount = 0;
      this.pedigreeHasAppRemoved = null;
      this.pedigree = [];
      this.generatePedigree();
    },

    handlePedigree() {
      this.filtersPedigree.eventName = '';
      this.pedigreePage = 1;
      this.pedigreeCount = 0;
      this.pedigreeHasAppRemoved = null;
      this.pedigree = [];
      this.generatePedigree();
    },

    handleQriHistory() {
      this.loadQriHistory();
    },

    handleQriDateChange() {
      let now = new this.$moment();
      switch(this.filtersQri.dates.selected) {
        case "always":
          this.filtersQri.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersQri.toDate = now.format('YYYY-MM-DD');
          break;
        case "week":
          this.filtersQri.toDate = now.format('YYYY-MM-DD');
          this.filtersQri.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersQri.toDate = now.format('YYYY-MM-DD');
          this.filtersQri.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersQri.toDate = now.format('YYYY-MM-DD');
          this.filtersQri.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersQri.toDate = now.format('YYYY-MM-DD');
          this.filtersQri.fromDate = now.subtract(2, 'month').startOf('month').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersQri.toDate = now.format('YYYY-MM-DD');
          this.filtersQri.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersQri.fromDate = null;
          this.filtersQri.toDate = null;
          break;
      }
    },

    generatePedigree() {
      if (this.getUserRole !== Role.Admin && this.getUserRole !== Role.Marketing) {
        this.$toast.error("Unauthorized Section");
        return;
      }

      this.isLoadingPedigree = true;
      const params = {
        page: this.pedigreePage -1,
        count: this.pedigreeCount,
        hasAppRemoved: this.pedigreeHasAppRemoved,
        registeredAt: new Date(this.user.createdAt).getTime() / 1000
      }

      if (!isEmpty(this.filtersPedigree.eventName)) {
        params.eventName = this.filtersPedigree.eventName;
      }

      if (!isEmpty(this.filtersPedigree.eventType.selected)) {
        params.eventType = this.filtersPedigree.eventType.selected;
      }

      UsersDataService.getPedigree(this.user.userId, params)
          .then((response) => {
            this.isLoadingPedigree = false;
            this.isLoadedPedigree = true;
            const { items, totalItems, hasAppRemoved } = response.data;
            if (!isEmpty(items)) {
              this.pedigree = items;
              this.pedigreeCount = totalItems;
              this.pedigreeHasAppRemoved = hasAppRemoved;
            }
          })
          .catch(error => {
            this.isLoadingPedigree = false;
            if (this.pedigreePage === 0) {
              this.isLoadedPedigree = true;
            }
            window.console.error(error);
          });
    },

    generateActions() {
      if (this.getUserRole !== Role.Admin && this.getUserRole !== Role.Marketing) {
        this.$toast.error("Unauthorized Section");
        return;
      }

      this.isLoadingActions = true;
      const params = {
        page: this.actionsPage -1,
        count: this.actionsCount,
        registeredAt: new Date(this.user.createdAt).getTime() / 1000
      }

      UsersDataService.getActionsGenerator(this.user.userId, params)
          .then((response) => {
            this.isLoadingActions = false;
            this.isLoadedActions = true;
            const { items, totalItems, stats } = response.data;
            if (!isEmpty(items)) {
              this.actions = items;
              this.actionsCount = totalItems;
              this.actionsStats = stats;
              this.getGeneratorMediaThumb();
            }
          })
          .catch(error => {
            this.isLoadingActions = false;
            if (this.actionsPage === 0) {
              this.isLoadedActions = true;
            }
            window.console.error(error);
          });
    },

    getActionsMediaThumb() {
      if (this.actionsList.length > 0)
        this.actionsList.forEach(action => {
          if (action.userPhoto && action.userPhoto.length > 0)
            Storage.getUserMedia(action.memberId, action.userPhoto, 'action-member-'+action.actionId);
        });
    },

    getGeneratorMediaThumb() {
      if (this.actions.length > 0) {
        this.actions.forEach((action, index) => {
          if (action.memberPhoto && action.memberPhoto.length > 0)
            Storage.getUserMedia(action.memberId, action.memberPhoto, 'generator-member-'+index);
        });
      }
    },

    setPhoneDetails(event) {
      this.phoneDetails = event;
      if (event.isValid === true) {
        this.privateInfo.phone = this.phoneDetails.formatInternational;
      }
    },

    _isEmpty(val) {
      return isEmpty(val);
    },

    searchReverseImage(url) {
      const searchUrl = `https://yandex.com/images/search?rpt=imageview&url=${encodeURI(url)}`;
      window.open(searchUrl, '_blank');
    },
  },

  watch: {
    user: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal !== null ) {
            this.initUser();
          }
        }
      },
      immediate: true
    },
    publicInfo: {
      handler: function (newVal){
        let changed = false;
        if (newVal.name !== this.user.name && !changed)
          changed = true;

        if (!changed && newVal.minAge !== this.user.minAge)
          changed = true;

        if (!changed && newVal.maxAge !== this.user.maxAge)
          changed = true;

        if (!changed && newVal.locality !== this.user.locality)
          changed = true;

        if (!changed && newVal.sex !== this.user.sex)
          changed = true;

        if (!changed && !this.arraysContainSame(newVal.search, this.user.search))
          changed = true;

        if (!changed && !this.arraysContainSame(newVal.searchType, this.user.searchType))
          changed = true;

        if (!changed && newVal.birth !== this.user.birth)
          changed = true;

        if (!changed && newVal.country !== this.user.country)
          changed = true;

        if (!changed && newVal.distance !== this.user.searchDistance)
          changed = true;

        this.changePublicInfo = changed;
      },
      deep: true,
    },
    privateInfo: {
      handler: function (newVal) {
        if (!this.isUserInit)
          return;

        let changed = false;
        if (newVal.email !== this.user.email) {
          changed = true;
        }

        if (!changed) {
          if (newVal.phone === null) newVal.phone = '';
          if (newVal.phone !== this.user.phone) {
            changed = true;
          }
        }

        this.changePrivateInfo = changed;
      },
      deep: true,
    },
    description: {
      handler: function () {
        if (!this.isDescriptionInit) return;
        this.changeDescription = this.description !== this.user.description;
      }
    }
  },

  computed: {
    ...authComputed,

    getUserRole() {
      return getRole(this.getRole);
    }
  },

  created() {
    if (this.getUserRole === Role.Admin || this.getUserRole === Role.Marketing) {
      this.isAdmin = true;
    }
  },

  mounted() {
    this.loadAnnotations();
  },

  data() {
    return {
      mediaOptions: {
        type     : 'loop',
        perPage: 3,
        perMove: 1,
        gap: '6px',
        cover: true,
        fixedHeight: '9rem'
      },
      isAdmin: false,
      media: [],
      mainMedia: null,
      tabIndex:0,
      tabInterestsIndex:0,
      tabCreditsIndex:0,
      pedigreePage: 1,
      actionsPage: 1,
      pedigreeCount: 0,
      actionsCount: 0,
      actionsStats: {
        matches: '',
        iceBreakers: '',
        threads: '',
        answers: '',
        messages: '',
        likes: '',
      },
      pedigreeHasAppRemoved: null,
      isUpdating: false,
      isLoadingPedigree: false,
      isLoadingActions: false,
      isLoadingQri: false,
      isLoadedPedigree: false,
      isLoadedActions: false,
      isLoadingMedia: false,
      pedigree:[],
      actions:[],
      changePublicInfo: false,
      changePrivateInfo: false,
      changeDescription: false,
      changeLifestyle: false,
      changeInterests: false,
      changeAlerts: false,
      changeTokens: false,
      publicInfo: {
        name: '',
        birth: '',
        sex: 0,
        search: [],
        searchType: [],
        minAge: 0,
        maxAge: 0,
        distance: 0,
        country: '',
        locality: '',
        countries: {
          selected: { alpha2: '', name: '' },
          options: require(`@/assets/json/countries_${this.$i18n.locale}.json`)
        },
      },
      isUserInit: false,
      phoneDetails: null,
      phoneNumber: '',
      privateInfo: {
        email: '',
        phone: '',
      },
      search:[
        { value: 1, label: this.$t("user.male")},
        { value: 2, label: this.$t("user.female")}
      ],
      searchType:[
        { value: 1, label: this.$t("search.type_serious")},
        { value: 2, label: this.$t("search.type_fun")},
        { value: 4, label: this.$t("search.type_friend")},
        { value: 3, label: this.$t("search.type_undecided")}
      ],
      isDescriptionInit: false,
      description: '',
      lifeStyle: null,
      lifeStyleSelected: null,
      interests: null,
      interestsSelected: null,
      tokens: [],
      alertsE: null,
      alertsP: null,
      alertsESelected: null,
      alertsPSelected: null,
      annotation: '',
      annotationsList: [],
      subscriptionsList: [],
      paymentsList: [],
      userPacks: {
        iceBreakers: [],
        boosts: [],
      },
      qriStats: {
        minQri: '-',
        maxQri: '-',
        currentQri: '-',
      },
      actionsList: [],
      filtersPedigree: {
        eventType: {
          selected: '',
          options: [
            {value: '', text: 'All types'},
            {value: 'app', text: 'App'},
            {value: 'enter', text: 'Enter'},
            {value: 'screen', text: 'Screen'},
            {value: 'spreedl', text: 'Spreedl Game'},
            {value: 'spreedl packets', text: 'Spreedl Packets'},
            {value: 'payment', text: 'Payment'},
            {value: 'notification', text: 'Notifications'},
            {value: 'email', text: 'Email'},
            {value: 'other', text: 'Other'},
          ]
        },
        eventName: ''
      },
      filtersQri: {
        dates: {
          dateRange: null,
          selected: 'last30Day',
          options: [
            {value: 'week', text: this.$t("dates.week")},
            {value: 'curMonth', text: this.$t("dates.curMonth")},
            {value: 'last30Day', text: this.$t("dates.last30Day")},
            {value: 'last3Month', text: this.$t("dates.last3Month")},
            {value: 'curYear', text: this.$t("dates.curYear")},
            {value: 'always', text: this.$t("dates.always")},
            {value: 'custom', text: this.$t("dates.custom")}
          ]
        },
        fromDate: null,
        toDate: null,
      },
      scoreGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'line',
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'user-score'
                },
                svg: {
                  filename: 'user-score'
                }
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: [2]
          },
          colors: ["#556ee6"],
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
              },
              title: {
                text: "QRI",
              },
              tooltip: {
                enabled: true
              }
            }
          ],
          tooltip: {
            shared: true,
            intersect: false
          },
          legend: {
            position: 'bottom',
          }
        },
      },
    }
  }
}
</script>

<template>
  <div v-if="typeof user.email !== 'undefined'" :id="`user-${user.userId}`" class="position-relative">
    <b-card v-show="isUserInit" no-body bg-variant="info" class="text-white" :style="user.sex === 2 ? {backgroundColor: '#f06292 !important'} : {}">
      <b-row no-gutters class="align-items-center">
        <b-col md="4" style="position:relative;">
          <b-card-img :id="`user-img-${user.userId}`" :src="mainMedia" class="rounded-0">
          </b-card-img>
          <b-button variant="primary" style="position:absolute;bottom:10px;left:15px;right:15px;" @click="searchReverseImage(mainMedia)">Google Search</b-button>
        </b-col>
        <b-col md="8">
          <b-card-body>
            <h4 class="mt-0 mb-2 text-white">
              <img :src="getSubscribeImg(user.isSubscribed)" /> {{ user.name }}, <small>{{ getAge(user.birth) }}</small> <i v-show="user.status === 'online'" class="fas fa-circle text-success"></i>
            </h4>
            <div class="card-text mb-3" v-if="user.isQualityUser === 1">
              <span class="badge bg-success font-size-15 text-light">{{ $t(`marketing.quality_user_1`) }}</span>
            </div>
            <div class="card-text font-size-14 user-primary-info">
              <i class="fas fa-address-book rounded-circle p-1 text-info" :style="user.sex === 2 ? {color: '#f06292 !important'} : {}"></i>&nbsp;{{ user.email }}
            </div>
            <div class="card-text font-size-14 user-primary-info">
              <i class="fas fa-hashtag rounded-circle p-1 text-info" :style="user.sex === 2 ? {color: '#f06292 !important'} : {}"></i>&nbsp;{{ user.userId }}
            </div>
            <div class="card-text font-size-14 user-primary-info">
              <i class="fas fa-phone-square-alt rounded-circle p-1 text-info" :style="user.sex === 2 ? {color: '#f06292 !important'} : {}"></i>&nbsp;{{ user.phone || ' +XX XXX.XXX.XX '}}
            </div>
            <div class="card-text font-size-14 user-primary-info">
              <i class="far fa-clock rounded-circle p-1 text-info" :style="user.sex === 2 ? {color: '#f06292 !important'} : {}"></i>&nbsp;{{ $t('user.last_seen') }}&nbsp;{{ new Date(user.loggedAt) | moment('DD MMM YYYY HH:mm') }}
            </div>
            <div class="card-text font-size-14 user-primary-info">
              <i class="fas fa-star rounded-circle p-1 text-info" :style="user.sex === 2 ? {color: '#f06292 !important'} : {}"></i>&nbsp;QRIndex&nbsp;{{ user.qrIndex || '-' }}
            </div>
            <b-button variant="primary m-1" class="mt-4 mb-2" v-if="parseInt(user.checked) === 0" @click="checkedUser">
              {{ $t("markAsVerify") }}
            </b-button>
            <div v-else class="card-text font-size-14 user-primary-info">
              <i class="bx bx-check rounded-circle p-1 text-info" :style="user.sex === 2 ? {color: '#f06292 !important'} : {}"></i>&nbsp;{{ new Date(user.checkedAt) | moment('DD MMM YYYY HH:mm') }} ({{ getInitials(user.checkedBy) }})
            </div>
          </b-card-body>
        </b-col>
        <div v-show="user.disabled === 1" class="ribbon ribbon-top-right"><span>{{ $t('user_disabled') }}</span></div>
      </b-row>
    </b-card>

    <b-tabs v-show="isUserInit" content-class="" v-model="tabIndex">
      <!-- user Info Public -->
      <b-tab>
        <template #title>
          <i class="far fa-user"></i> {{ $t('user.info') }}
        </template>
        <div class="card">
          <div class="card-body">
            <b-form id="publicInfoForm" @submit.stop.prevent>
              <div class="row">
                <div class="col-lg-6">
                  <b-form-group
                      :label="$t('name')"
                      label-for="user_name">
                    <b-form-input
                        id="user_name"
                        v-model="publicInfo.name"
                        type="text"
                        :placeholder="$t('user.name_placeholder')"
                        required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-lg-6">
                  <b-form-group
                      :label="$t('user.birth')"
                      label-for="user_birth">
                    <date-picker
                        id="user_birth"
                        type="date"
                        value-type="format"
                        show-week-number
                        v-model="publicInfo.birth"
                        append-to-body ></date-picker>

                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 mt-3">
                  <label class="mb-0 me-3">{{ $t('gender') }}</label>
                  <br>
                  <toggle-button
                      @change="onChangeSex"
                      :width="110"
                      :height="30"
                      :value="publicInfo.sex === 1"
                      :labels="{checked: this.$t('user.male'), unchecked: this.$t('user.female')}"
                      :color="{checked: '#42a5f5', unchecked: '#f06292'}"
                  />
                </div>
                <div class="col-lg-4 mt-3">
                  <label class="mb-0 me-3">{{ $t('genderSearch') }}</label>
                  <b-form-checkbox v-for="item in search" :key="item.value"
                    :value="item.value"
                    class="mb-1"
                    plain
                    v-model="publicInfo.search"
                    :checked="publicInfo.search.includes(item.value)"
                  >
                    {{ item.label }}
                  </b-form-checkbox>
                </div>
                <div class="col-lg-4 mt-3">
                  <label class="mb-0 me-3">{{ $t('typeSearch') }}</label>
                  <b-form-checkbox v-for="item in searchType" :key="item.value"
                     :value="item.value"
                     class="mb-1"
                     plain
                     v-model="publicInfo.searchType"
                     :checked="publicInfo.searchType.includes(item.value)"
                  >
                    {{ item.label }}
                  </b-form-checkbox>
                </div>
              </div>
              <div class="row ">
                <div class="col-lg-4 mt-3">
                  <b-form-group
                      :label="$t('user.country')"
                      label-for="user_country">
                    <multiselect
                        v-model="publicInfo.countries.selected"
                        @input="onChangeCountry"
                        id="user_country"
                        :multiple="false"
                        label="name"
                        track-by="name"
                        :allowEmpty="false"
                        :close-on-select="true"
                        :placeholder="$t('user.country')"
                        :options="publicInfo.countries.options">
                      <template slot="singleLabel">
                        <country-flag :rounded="true" size='small' :country='publicInfo.countries.selected.alpha2' />
                        <div class="d-inline ms-2">{{ publicInfo.countries.selected.name }}</div>
                      </template>
                      <template slot="option" slot-scope="props">
                        <country-flag :rounded="true" size='small' :country='props.option.alpha2' />
                        <div class="d-inline ms-2">{{ props.option.name }}</div>
                      </template>
                    </multiselect>

                  </b-form-group>
                </div>
                <div class="col-lg-8 mt-3">
                  <b-form-group
                      :label="$t('user.locality')"
                      label-for="user_locality">
                    <b-form-input
                        id="user_locality"
                        v-model="publicInfo.locality"
                        type="text"
                        required
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row ">
                <div class="col-lg-3 mt-2">
                  <b-form-group
                      :label="$t('user.min_age')"
                      label-for="user_min_age">
                      <b-form-input
                          id="user_min_age"
                          @change="onChangeMinAge"
                          :min="18"
                          :max="99"
                          :value="publicInfo.minAge"
                          type="number"
                          required
                          ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-lg-3 mt-2">
                  <b-form-group
                      :label="$t('user.max_age')"
                      label-for="user_max_age">
                    <b-form-input
                        id="user_max_age"
                        @change="onChangeMaxAge"
                        :value="publicInfo.maxAge"
                        :min="19"
                        :max="100"
                        type="number"
                        required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-lg-6 mt-2">
                  <b-form-group
                      :label="$t('user.distance')"
                      label-for="user_distance">
                    <div class="form-control">
                      <b-form-input
                          :value="publicInfo.distance"
                          @change="onChangeDistance"
                          type="range"
                          :min="0"
                          :max="500"
                          style="margin-top:2px;"
                          required
                      ></b-form-input>
                      <b-form-input
                          id="user_distance"
                          @change="onChangeDistance"
                          :value="publicInfo.distance"
                          :max="500"
                          :min="0"
                          type="number"
                          class="d-inline-block w-auto p-1 ms-1"
                          required
                      ></b-form-input>
                      <b>&nbsp;km</b>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div v-show="changePublicInfo" class="text-center border-top mt-2 pt-2">
                <b-button class="m-2" variant="primary" @click="savePublicInfo">
                  <b-icon icon="cloud-upload-fill" animation="fade"></b-icon> {{ $t("save") }}
                </b-button>
                <b-button class="m-2" variant="outline-danger" animation="fade" @click="resetPublicInfo">
                  {{ $t("cancel") }}
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </b-tab>
      <!-- Media -->
      <b-tab>
        <template #title>
          <i class="fas fa-image"></i> {{ $t('user.media') }} <span class="badge bg-danger">{{ user.countMedia }}</span>
        </template>
        <div class="card">
          <div class="card-body">
            <div class="row d-flex justify-content-center">
              <vue-ellipse-progress
                  v-show="isLoadingMedia"
                  :loading="isLoadingMedia"
                  :angle="-90"
                  color="#50a5f1"
                  emptyColor="#999"
                  emptyColorFill="#f8f8fb"
                  :size="75"
                  :thickness="3"
                  :emptyThickness="2"
                  lineMode="out 2"
                  animation="bounce 700 400"
                  fontColor="#666"
                  :half="false"
                  class="mt-5 mb-5"
                  fontSize="1rem">
              </vue-ellipse-progress>
            </div>

            <div class="gallery mb-2">
              <div class="gallery-panel position-relative"
                   v-for="medium in media"
                   :key="medium.mediaId">
                <div class="img" v-show="medium.isValid" :style="{backgroundImage: `url(${medium.srcThumb})`}" @click="showMedia(`${medium.mediaId}`)"></div>
                <div class="img" v-show="!medium.isValid && medium.typeMedia === 0" :style="{backgroundImage: `url(${medium.src})`}" @click="showMedia(`${medium.mediaId}`)"></div>
                <div class="img" v-show="!medium.isValid && medium.typeMedia === 1" :style="{backgroundImage: `url(${medium.srcThumb})`}" @click="showMedia(`${medium.mediaId}`)"></div>
                <div v-show="!medium.isValid" class="mini-ribbon mini-ribbon-top-right"><span>{{ $t('invalid') }}</span></div>
                <div v-show="medium.rankMedia === 1 && medium.typeMedia === 0" class="mini-ribbon mini-ribbon-top-left"><span>{{ $t('profile') }}</span></div>
                <div v-show="medium.rankMedia === 1 && medium.typeMedia === 1" class="mini-ribbon mini-ribbon-top-left"><span>SPREEDL</span></div>
                <div class="p-2 d-flex align-items-center justify-content-between">
                  <span class="gallery-number">{{ medium.rankMedia }}</span>
                  <b-dropdown
                      class="card-drop"
                      variant="white"
                      menu-class="dropdown-menu-end"
                      right
                      toggle-class="p-0"
                  >
                    <template v-slot:button-content>
                      <i class="mdi mdi-settings-helper font-size-18"></i>
                    </template>
                    <b-dropdown-item
                        href="javascript: void(0);"
                        @click="searchReverseImage(medium.src)"
                    >Google Search</b-dropdown-item>
                    <b-dropdown-item
                        v-show="medium.rankMedia !== 1"
                        href="javascript: void(0);"
                        @click="setMediaAsMain(medium)"
                    >{{ $t("media.setMain") }}</b-dropdown-item>
                    <b-dropdown-item
                        href="javascript: void(0);"
                        @click="deleteMedia(medium)"
                    >{{ $t("delete") }}</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- user info private -->
      <b-tab>
        <template #title>
          <i class="fas fa-lock"></i> {{ $t('user.info_private') }}
        </template>
        <div class="card">
          <div class="card-body" style="min-height: 250px">
            <b-form id="privateInfoForm" @submit.stop.prevent>
              <div class="row">
                <b-form-group
                    :label="$t('email')"
                    label-for="user_email"
                    label-cols-lg="3"
                    content-cols-lg="9"
                >
                  <b-form-input
                      id="user_email"
                      v-model="privateInfo.email"
                      type="email"
                      :placeholder="$t('user.email_placeholder')"
                      required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="row mt-2">
                <b-form-group
                    :label="$t('user.phone')"
                    label-cols-lg="3"
                    content-cols-lg="9"
                >
                  <MazPhoneNumberInput
                      v-model="phoneNumber"
                      @update="setPhoneDetails($event)"
                  />
                </b-form-group>
              </div>
              <div class="row mt-2">
                <b-form-group
                    :label="$t('user.registeredAt')"
                    label-cols-lg="3"
                    content-cols-lg="9"
                >
                  <div class="form-control"><i class="bx bx-calendar-event"></i> {{ new Date(user.createdAt) | moment('DD MMM YYYY HH:mm') }}</div>
                </b-form-group>
              </div>
              <div class="row mt-2">
                <b-form-group
                    :label="$t('lastip')"
                    label-cols-lg="3"
                    content-cols-lg="9"
                >
                  <div class="form-control"><i class="fas fa-network-wired"></i> {{ user.ip || 'no ip found…' }}</div>
                </b-form-group>
              </div>
              <div class="row mt-2">
                <b-form-group
                    :label="$t('registerip')"
                    label-cols-lg="3"
                    content-cols-lg="9"
                >
                  <div class="form-control"><i class="fas fa-network-wired"></i> {{ user.registerIp || 'no registerIp found…' }}</div>
                </b-form-group>
              </div>
              <div class="row mt-2">
                <b-form-group
                    :label="$t('source')"
                    label-cols-lg="3"
                    content-cols-lg="9"
                >
                  <div class="form-control">{{ user.adSource }} - {{ user.adCampaign }}</div>
                </b-form-group>
              </div>
              <div class="row mt-2">
                <b-form-group
                    label="SLGroup / PMGroup"
                    label-cols-lg="3"
                    content-cols-lg="9"
                >
                  <div class="form-control">{{ user.slGroup }} / {{ user.pmGroup }}</div>
                </b-form-group>
              </div>
              <div v-show="changePrivateInfo" class="text-center border-top mt-2 pt-2">
                <b-button class="m-2" variant="primary" @click="savePrivateInfo">
                  <b-icon icon="cloud-upload-fill" animation="fade"></b-icon> {{ $t("save") }}
                </b-button>
                <b-button class="m-2" variant="outline-danger" animation="fade" @click="resetPrivateInfo">
                  {{ $t("cancel") }}
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <h5 class="text-primary">{{ $t("action") }}</h5>
            <div class="p-2 d-flex flex-wrap justify-content-between">
              <b-button variant="outline-danger m-1" @click="confirmDeleteUser">
                <b-icon icon="trash-fill"></b-icon> {{ $t("delete_account") }}
              </b-button>
              <b-button v-show="user.disabled === 0" variant="outline-warning m-1" @click="disableUser">
                <b-icon icon="patch-exclamation-fill"></b-icon> {{ $t("disable_account") }}
              </b-button>
              <b-button v-show="user.disabled === 1" variant="outline-info m-1" @click="enableUser">
                <b-icon icon="patch-exclamation-fill"></b-icon> {{ $t("enable_account") }}
              </b-button>
              <b-button variant="outline-secondary m-1" @click="blockPhone">
                <b-icon icon="lock-fill"></b-icon> {{ $t("block_phone") }}
              </b-button>
              <b-button variant="outline-secondary m-1" @click="blockIP">
                <b-icon icon="hdd-network-fill"></b-icon> {{ $t("block_ip") }}
              </b-button>
            </div>
          </div>
        </div>

      </b-tab>
      <!-- Payment -->
      <b-tab>
        <template #title>
          <i class="fas fa-dollar-sign"></i> {{ $t('user.payments') }}
        </template>
        <div>
          <!-- packs -->
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">{{ $t("user.packs_title") }}</h5>
              <b-tabs content-class="pt-2 font-size-14 border rounded-bottom" v-model="tabCreditsIndex" class="">
                <!-- Actions / Counters -->
                <b-tab>
                  <template #title>
                    {{ $t("user.packs_counters") }}
                  </template>
                  <div class="p-3">
                    <span class="badge bg-danger text-white fs-5">{{ user.iceBreakers }}</span>
                    <h6 class="d-inline-block ms-2">{{ $t("user.iceBreakers") }}</h6>
                    <div class="table-responsive" v-if="userPacks.iceBreakers.length > 0">
                      <table
                          class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                      >
                        <thead>
                        <tr>
                          <th scope="col">{{ $t('user.packs_status') }}</th>
                          <th scope="col">{{ $t('user.packs_count') }}</th>
                          <th scope="col">{{ $t('user.packs_data') }}</th>
                          <th scope="col">{{ $t('user.packs_canceledAt') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr v-for="pack in userPacks.iceBreakers" :key="pack.packId">
                            <td>
                              <span
                                  class="badge"
                                  :class="{
                                  'bg-success text-light': `${pack.status}` === 'A',
                                  'bg-warning text-dark': `${pack.status}` === 'C',
                                }">{{ $t(`user.packs_status_${pack.status}`) }}
                              </span>
                              <p class="text-muted font-size-12">
                                {{ formatDateString(pack.startedAt, 'DD MMM YYYY HH:mm') }}
                              </p>
                            </td>
                            <td>
                              <b>{{ pack.value }}</b>
                            </td>
                            <td>
                              <p class="text-muted font-size-12">
                                {{pack.amount / 100}} {{pack.currency}}
                              </p>
                            </td>
                            <td>
                              <b-button v-if="pack.status === 'A' && pack.packId === user.iceBreakersReloadId" variant="outline-danger" @click="cancelUserPack(pack)">
                                <b-icon icon="trash-fill" animation="fade"></b-icon> {{ $t("user.packs_terminate") }}
                              </b-button>
                              <p class="text-muted font-size-12" v-else>
                                {{ formatDateString(pack.canceledAt, 'DD MMM YYYY HH:mm') }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p v-else>
                      {{ $t("user.packs_iceBreakers_no_pack") }}
                    </p>

                    <hr />

                    <span class="badge bg-danger text-white fs-5">{{ user.boosts }}</span>
                    <h6 class="d-inline-block ms-2">{{ $t("user.boosts") }}</h6>
                    <div class="table-responsive" v-if="userPacks.boosts.length > 0">
                      <table
                          class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                      >
                        <thead>
                        <tr>
                          <th scope="col">{{ $t('user.packs_status') }}</th>
                          <th scope="col">{{ $t('user.packs_count') }}</th>
                          <th scope="col">{{ $t('user.packs_data') }}</th>
                          <th scope="col">{{ $t('user.packs_canceledAt') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="pack in userPacks.boosts" :key="pack.packId">
                          <td>
                            <span
                                class="badge"
                                :class="{
                                    'bg-success text-light': `${pack.status}` === 'A',
                                    'bg-warning text-dark': `${pack.status}` === 'C',
                                  }">{{ $t(`user.packs_status_${pack.status}`) }}
                                </span>
                            <p class="text-muted font-size-12">
                              {{ formatDateString(pack.startedAt, 'DD MMM YYYY HH:mm') }}
                            </p>
                          </td>
                          <td>
                            <b>{{ pack.value }}</b>
                          </td>
                          <td>
                            <p class="text-muted font-size-12">
                              {{pack.amount / 100}} {{pack.currency}}
                            </p>
                          </td>
                          <td>
                            <b-button v-if="pack.status === 'A' && pack.packId === user.boostsReloadId" variant="outline-danger" @click="cancelUserPack(pack)">
                              <b-icon icon="trash-fill" animation="fade"></b-icon> {{ $t("user.packs_terminate") }}
                            </b-button>
                            <p class="text-muted font-size-12" v-else>
                              {{ formatDateString(pack.canceledAt, 'DD MMM YYYY HH:mm') }}
                            </p>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <p v-else>
                      {{ $t("user.packs_boosts_no_pack") }}
                    </p>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    {{ $t("user.packs_history") }}
                  </template>
                  <div>
                    <div class="table-responsive" v-if="actionsList.length > 0">
                      <table
                          class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                      >
                        <thead>
                        <tr>
                          <th scope="col">{{ $t('credits.createdAt') }}</th>
                          <th scope="col">{{ $t('credits.number') }}</th>
                          <th scope="col">{{ $t('credits.type') }}</th>
                          <th scope="col">{{ $t('credits.member') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="action in actionsList" :key="action.actionId">
                          <td>
                            <p class="text-muted font-size-12">
                              <i class="bx bx-calendar-event"></i>{{ formatDateString(action.actionAt, 'DD MMM YYYY HH:mm') }}
                            </p>
                          </td>
                          <td>
                            <p class="text-muted font-size-12">{{ action.credits }}</p>
                          </td>
                          <td>
                            <p class="text-muted font-size-12"><strong>{{ action.name }}</strong></p>
                          </td>
                          <td>
                            <div class="media" v-if="action.memberId !== null">
                              <div class="avatar-xs">
                                <img
                                    :id="`action-member-${action.actionId}`"
                                    :src="require('@/assets/images/users/default-user.png')"
                                    class="d-flex rounded-circle avatar-xs" />
                              </div>
                              <div class="media-body ms-1">
                                <h5 class="font-size-12 mb-0">
                                <span
                                    :class="{
                                    'text-primary': action.userSex === 1,
                                    'text-danger': action.userSex === 2,
                                    'text-dark': action.userSex === 0,
                                  }"
                                >
                                  {{ action.userName || '-' }}
                                </span> {{ getAge(action.userBirth) }}</h5>
                                <small class="text-muted">#{{ action.memberId }}</small>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="m-2 text-center">
                      Aucun crédit utilisé…
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>

          <!-- Subscriptions -->
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">{{ $t("user.subscriptions") }}</h5>

              <div v-if="user.isSubscribed === 2">
                <b>{{ $t("user.lifetime_premium") }}</b>
                <p class="font-size-12 mt-2">
                  <span class="d-block mb-3" v-if="user.hasLifeTimeEnabled === 1">
                    {{ $t("user.since")}}: {{ formatDateString(user.hasLifeTimeStartedAt, 'DD MMM YYYY HH:mm') }}
                  </span>
                  <b-button variant="outline-danger" @click="removePremium()">
                    <b-icon icon="trash-fill" animation="fade"></b-icon> {{ $t("user.remove_premium") }}
                  </b-button>
                </p>

              </div>

              <div class="table-responsive" v-if="subscriptionsList.length > 0">
                <table
                    id="subscriptions-list"
                    class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                >
                  <thead>
                  <tr>
                    <th scope="col">{{ $t('finance.status') }}</th>
                    <th scope="col">{{ $t('finance.subscription') }}</th>
                    <th scope="col">{{ $t('finance.orderid') }}</th>
                    <th scope="col">{{ $t('finance.amount') }}</th>
                    <th scope="col">{{ $t('finance.createdAt') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="subscription in subscriptionsList" :key="subscription.id">
                      <td>
                        <span
                            class="badge"
                            :class="{
                              'bg-success text-light': `${subscription.status}` === 'A',
                              'bg-danger text-light': `${subscription.status}` === 'S',
                              'bg-warning text-light': `${subscription.status}` === 'C',
                              'bg-pink text-text': `${subscription.status}` === 'E',
                            }"
                        >{{ $t(`finance.status_sub_${subscription.status}`) }}</span>
                        <p class="text-muted font-size-12">
                          <i class="bx bx-calendar-event"></i><span class="text-info">{{ formatDateString(subscription.startedAt, 'DD MMM YYYY HH:mm') }}</span>
                        </p>
                      </td>
                      <td>
                        <p class="text-muted font-size-12">{{ $t(`finance.${subscription.productId}`) }}</p>
                      </td>
                      <td>
                        <p class="text-muted font-size-12"><strong>{{ subscription.orderId }}</strong></p>
                        <b-button v-show="subscription.documentId === user.subscriptionId && (subscription.status === 'A' || subscription.status === 'S') " variant="outline-warning" @click="cancelSubscription(subscription)">
                          <b-icon icon="trash-fill" animation="fade"></b-icon> {{ $t("user.packs_terminate") }}
                        </b-button>
                        <b-button class="ms-2" v-show="subscription.documentId === user.subscriptionId && (subscription.status !== 'E') " variant="outline-danger" @click="deleteSubscription(subscription)">
                          <b-icon icon="trash-fill" animation="fade"></b-icon> {{ $t("user.delete_sub") }}
                        </b-button>
                      </td>
                      <td>
                        <p class="font-size-12" >
                          <span
                              class="text-dark fw-bold d-inline-block me-2 text-primary"
                          >{{ subscription.amount/100 }} {{ subscription.currency }}</span>
                        </p>
                      </td>
                      <td>
                        <p class="text-muted font-size-12">
                          <span class="d-block" v-if="!_isEmpty(subscription.suspendedAt)">
                            Suspended: {{ formatDateString(subscription.suspendedAt, 'DD MMM YYYY HH:mm') }}
                          </span>
                          <span class="d-block" v-if="!_isEmpty(subscription.canceledAt)">
                            Cancel: {{ formatDateString(subscription.canceledAt, 'DD MMM YYYY HH:mm') }}
                          </span>
                          <span class="d-block" v-if="!_isEmpty(subscription.endedAt)">
                            End: {{ formatDateString(subscription.endedAt, 'DD MMM YYYY HH:mm') }}
                          </span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-else class="text-center mt-3">
                {{ $t("user.no_subscription")}}
              </div>
            </div>
          </div>

          <!-- Payments -->
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">{{ $t("user.transactions") }}</h5>
              <div class="table-responsive" v-if="paymentsList.length > 0">
                <table
                    id="payments-list"
                    class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                >
                  <thead>
                  <tr>
                    <th scope="col">{{ $t('finance.status') }}</th>
                    <th scope="col">{{ $t('finance.product') }}</th>
                    <th scope="col">{{ $t('finance.orderid') }}</th>
                    <th scope="col">{{ $t('finance.amount') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="transaction in paymentsList" :key="transaction.id">
                    <td>
                        <span
                            class="badge"
                            :class="{
                              'bg-success text-light': `${transaction.status}` === 'S',
                              'bg-info text-light': `${transaction.status}` === 'SS' || `${transaction.status}` === 'SR',
                              'bg-danger text-light': `${transaction.status}` === 'E',
                              'bg-light text-dark': `${transaction.status}` === 'F' || `${transaction.status}` === 'FR',
                              'bg-pink text-light': `${transaction.status}` === 'X' || `${transaction.status}` === 'C',
                              'bg-warning text-dark': `${transaction.status}` === 'I',
                              'bg-dark text-light': `${transaction.status}` === 'RF' || `${transaction.status}` === 'CB',
                            }">{{ $t(`finance.status_${transaction.status}`) }}</span>
                        <p class="text-muted font-size-12">
                          <i class="bx bx-calendar-event"></i>{{ formatDateString(transaction.createdAt, 'DD MMM YYYY HH:mm') }}
                        </p>
                    </td>
                    <td>
                      <p class="text-muted font-size-12">{{ $t(`finance.${transaction.productId}`) }}</p>
                    </td>
                    <td>
                      <p class="text-muted font-size-12"><strong>{{ transaction.orderId }}</strong></p>
                    </td>
                    <td>
                      <p class="font-size-12" >
                          <span
                              v-if="!['C','X'].includes(transaction.status)"
                              class="text-dark fw-bold d-inline-block me-2"
                              :class="{
                                'text-danger': `${transaction.status}` === 'RF' || `${transaction.status}` === 'CB',
                                'text-primary': `${transaction.status}` === 'S' || `${transaction.status}` === 'SR' || `${transaction.status}` === 'SS'
                              }"
                          >{{ transaction.amount/100 }} {{ transaction.currency }}</span>
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="m-2 text-center">
                Aucun paiement…
              </div>
            </div>
          </div>

        </div>
      </b-tab>
      <!-- Description -->
      <b-tab>
        <template #title>
          <i class="fas fa-font"></i> {{ $t('user.description') }}
        </template>
        <div>
          <!-- Introduction -->
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">Introduction</h5>
              <b-form-textarea
                v-model="description"
                id="user_description"
                class="mt-2 font-size-13"
                max-rows="10"
              ></b-form-textarea>
              <!-- buttons description -->
              <div v-show="changeDescription" class="text-center border-top mt-2 pt-2">
                <b-button class="m-2" variant="primary" @click="saveDescription">
                  <b-icon icon="cloud-upload-fill" animation="fade"></b-icon> {{ $t("save") }}
                </b-button>
                <b-button class="m-2" variant="outline-danger" animation="fade" @click="resetDescription">
                  {{ $t("cancel") }}
                </b-button>
              </div>
            </div>
          </div>
          <!-- lifeStyle -->
          <div class="card mt-3">
            <div class="card-body">
              <h5 class="text-primary">LifeStyle</h5>
              <b-form-group
                  v-for="category in lifeStyle" :item="category"
                  :key="category.id"
                  :label="$t(`lifestyle.category_${category.id}`)"
                  label-cols-lg="3"
                  content-cols-lg="9"
                  class="mb-3"
                  label-class="maz-text-bold"
              >
                <b-form-select
                    class="form-select"
                    v-model="category.selected"
                    @change="handleLifestyleValue(category.id, $event)">
                  <b-form-select-option value=""> -- </b-form-select-option>
                  <b-form-select-option
                      v-for="item in category.items"
                      :key="item.value"
                      :value="item.value"
                    >
                    {{ $t(`lifestyle.value_${item.text}`) }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <!-- buttons lifestyle -->
              <div v-show="changeLifestyle" class="text-center border-top mt-2 pt-2">
                <b-button class="m-2" variant="primary" @click="saveLifeStyle">
                  <b-icon icon="cloud-upload-fill" animation="fade"></b-icon> {{ $t("save") }}
                </b-button>
                <b-button class="m-2" variant="outline-danger" animation="fade" @click="resetLifeStyle">
                  {{ $t("cancel") }}
                </b-button>
              </div>
            </div>
          </div>
          <!-- interests -->
          <div class="card mt-3">
            <div class="card-body">
              <h5 class="text-primary">Interests</h5>
              <div class=" d-flex flex-wrap mb-3">
                <span v-for="interest in interestsSelected"
                      :key="interest.text"
                     class="inline-block border rounded-pill p-1 ps-2 pe-2 m-1"
                >
                  <i class="fas fa-circle font-size-10" :style="{color:`${interest.color}`}"></i>
                  {{ $t(`interests.value_${interest.text}`) }}
                  <i class="fas fa-times cursor-pointer" style="color:#999;" @click="handleInterestValue(interest.category, interest.text, interest.color)"></i></span>
              </div>
              <b-tabs content-class="pt-2 font-size-14 border rounded-bottom" v-model="tabInterestsIndex" class="">
                <b-tab v-for="category in interests"
                       :item="category"
                       :key="category.id">
                  <template #title>
                    {{ $t(`interests.category_${category.id}`) }}
                  </template>
                  <div style="min-height: 130px">
                    <p v-for="interest in category.items"
                       :item="interest"
                       :key="interest.id"
                       :class="[interest.selected ? 'interest-selected': 'interest-deselected']"
                       class="d-inline-block cursor-pointer m-2 p-1 rounded"
                       :style="[interest.selected ? {backgroundColor: `${category.color}`} : {color: '#111'}]"
                       >
                        #{{ $t(`interests.value_${interest.text}`) }} <i class="fas"
                                                                         @click="handleInterestValue(category.id, interest.text, category.color)"
                                                                         :class="[interest.selected ? 'fa-times' : 'fa-plus-circle']"></i>
                    </p>
                  </div>
                </b-tab>
              </b-tabs>
              <!-- buttons interests -->
              <div v-show="changeInterests" class="text-center border-top mt-2 pt-2">
                <b-button class="m-2" variant="primary" @click="saveInterests">
                  <b-icon icon="cloud-upload-fill" animation="fade"></b-icon> {{ $t("save") }}
                </b-button>
                <b-button class="m-2" variant="outline-danger" animation="fade" @click="resetInterests">
                  {{ $t("cancel") }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Social -->
     <!-- <b-tab>
        <template #title>
          <i class="fas fa-people-arrows"></i> {{ $t('user.social') }}
        </template>
        <div class="card">
          <div class="card-body" style="min-height: 250px">
            <b>No social content found</b>
          </div>
        </div>
      </b-tab>-->
      <!-- Settings -->
      <b-tab>
        <template #title>
          <i class="bx bx-wrench"></i> {{ $t('user.settings') }}
        </template>
        <div>
          <!-- tokens -->
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">Tokens</h5>
              <b-list-group v-show="tokens.length > 0">
                <b-list-group-item
                  v-for="token in tokens"
                  :key="token.token"
                  class="list-group-item px-0">
                  <b-row align-v="center" >
                    <b-col md="auto">
                    {{ token.token }}
                    </b-col>
                    <b-col md="auto">
                      <b-button type="button" size="sm" variany="primary" @click="deleteToken(token.token)">
                        <b-icon icon="trash"></b-icon>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
              <div v-show="tokens.length === 0" class="bordered mt-2">
                <b-icon variant="danger" icon="chat-left-dots-fill"></b-icon> {{ $t("user.empty_tokens") }}
              </div>
            </div>
          </div>
          <!-- Alerts -->
          <div class="card mt-3">
            <div class="card-body">
              <h5 class="text-primary">Notifications</h5>
              <h6 class="mt-3"><i class="bx bx-cloud-download text-primary font-size-15 me-2"></i>{{ $t("user.alertsPTitle") }}</h6>
              <b-list-group v-show="alertsP !== null">
                <b-list-group-item
                    v-for="alert in alertsP"
                    :key="alert.alertId"
                    class="list-group-item ps-2">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      {{ $t(`user.alerts.${alert.alertId}`) }}
                    </div>
                    <div cols="2" class="align-items-end">
                      <toggle-button
                          :width="50"
                          :height="20"
                          :value="alert.selected"
                          :labels="{checked: 'ON', unchecked: 'Off'}"
                          :color="{checked: '#42a5f5', unchecked: '#999999'}"
                          @change="handleAlertValue(alert.alertId, alert.typeAlert, $event)"
                      />
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
              <h6 class="mt-3"><i class="bx bx-message text-primary font-size-15 me-2"></i>{{ $t("user.alertsETitle") }}</h6>
              <b-list-group v-show="alertsE !== null">
                <b-list-group-item
                    v-for="alert in alertsE"
                    :key="alert.alertId"
                    class="list-group-item ps-2">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      {{ $t(`user.alerts.${alert.alertId}`) }}
                    </div>
                    <div cols="2" class="align-items-end">
                      <toggle-button
                          :width="50"
                          :height="20"
                          :value="alert.selected"
                          :labels="{checked: 'ON', unchecked: 'Off'}"
                          :color="{checked: '#42a5f5', unchecked: '#999999'}"
                          @change="handleAlertValue(alert.alertId, alert.typeAlert, $event)"
                      />
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
              <!-- buttons interests -->
              <div v-show="changeAlerts" class="text-center border-top mt-2 pt-2">
                <b-button class="m-2" variant="primary" @click="saveAlerts">
                  <b-icon icon="cloud-upload-fill" animation="fade"></b-icon> {{ $t("save") }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Qri History -->
      <b-tab>
        <template #title>
          <i class="bx bx-wrench"></i> {{ $t('user.qri_history') }}
        </template>
        <div>
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">QRI</h5>
              <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>
                  <!-- dates -->
                  <div class="col-sm-auto d-flex">
                    <b-form-select
                        id="userQriDatesFilter"
                        @change="handleQriDateChange"
                        v-model="filtersQri.dates.selected"
                        class="form-select me-lg-1"
                        :options="filtersQri.dates.options">
                    </b-form-select>
                    <date-picker
                        v-show="filtersQri.dates.selected === 'custom'"
                        lang="fr"
                        :placeholder="this.$t('choose_date_interval')"
                        type="date"
                        value-type="format"
                        show-week-number
                        v-model="filtersQri.dates.dateRange"
                        class="me-lg-2"
                        range append-to-body ></date-picker>

                  </div>
                <div class="col-sm-auto">
                  <b-button v-if="!isLoadingQri" variant="primary" class="w-md" @click="handleQriHistory">{{ $t("find") }}</b-button>
                </div>
              </b-form>

              <hr>
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingQri"
                    :loading="isLoadingQri"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Qri Data -->
              <div class="row">
                <div class="col-lg-4">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">QRI</p>
                          <h5 class="mb-0">{{ qriStats.currentQri }}</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div
                              class="avatar-title bg-info rounded-circle white font-size-20"
                          >
                            <i class="bx bx-stats"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Min QRI</p>
                          <h5 class="mb-0">{{  qriStats.minQri }}</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div
                              class="avatar-title bg-danger rounded-circle white font-size-20"
                          >
                            <i class="bx bxs-minus-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Max QRI</p>
                          <h5 class="mb-0">{{  qriStats.maxQri }}</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div
                              class="avatar-title bg-success rounded-circle white font-size-20"
                          >
                            <i class="bx bxs-to-top"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col-12">
                  <apexchart
                      ref="scoreChart"
                      class="apex-charts"
                      type="line"
                      dir="ltr"
                      height="300"
                      :series="scoreGraph.series"
                      :options="scoreGraph.chartOptions"
                  ></apexchart>
                </div>
              </div>

            </div>
          </div>
        </div>
      </b-tab>
      <!-- Misc -->
      <b-tab>
        <template #title>
          <i class="bx bx-message-square"></i> {{ $t('user.annotations') }}
        </template>
        <div>
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">{{ $t('user.historyAdd') }}</h5>
              <b-form-textarea
                  v-model="annotation"
                  id="user_annotation_add"
                  class="mt-2 font-size-13"
                  max-rows="10"
              ></b-form-textarea>
              <div v-show="annotation.length > 0" class="text-center border-top mt-2 pt-2">
                <b-button class="m-2" variant="primary" @click="addAnnotation">
                  <b-icon icon="cloud-upload-fill" animation="fade"></b-icon> {{ $t("save") }}
                </b-button>
                <b-button class="m-2" variant="outline-danger" animation="fade" @click="resetDescription">
                  {{ $t("cancel") }}
                </b-button>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">{{ $t('user.history') }}</h5>
              <b-list-group v-if="annotationsList.length > 0">
                <b-list-group-item v-for="anno in annotationsList" :key="anno.annotationId">
                  <div class="d-inline-block">
                    <i class="bx bx-calendar-event"></i><span class="text-secondary">{{ new Date(anno.dateAt) | moment('DD MMM YYYY HH:mm') }}</span>
                  </div>
                  <div class="d-inline-block ms-2">
                    <span class="badge rounded-pill bg-success">{{ anno.byName }}</span>
                  </div>
                  <p class="font-size-15  mt-2">{{ anno.message }}</p>
                </b-list-group-item>
              </b-list-group>
              <div v-else class="m-2 text-center">
                {{ $t("user.history_empty") }}
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Pedigree -->
      <b-tab>
        <template #title>
          <i class="bx bx-list-ul"></i> {{ $t('user.pedigree') }}
        </template>
        <div>
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">{{ $t("user.pedigree") }}
                <span v-show="pedigreeHasAppRemoved === true " class="badge bg-danger text-light me-2">App Désinstallée</span>
                <span class="text-dark" v-if="isLoadedPedigree"><small>{{ pedigreeCount }} {{ $t('resultsCount') }}</small></span>
              </h5>
              <span class="badge bg-success text-light font-size-14 mb-2">SL: {{ user.slGroup }}</span>
              <span class="badge bg-success text-light font-size-14 mb-2">PM: {{ user.pmGroup }}</span>
              <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>
                <div class="col-sm-auto">
                  <b-form-select
                      v-model="filtersPedigree.eventType.selected"
                      class="form-select me-lg-1"
                      :options="filtersPedigree.eventType.options">
                  </b-form-select>
                </div>
                <div class="col-sm-auto">
                  <b-button v-if="!isLoadingPedigree" variant="primary" class="w-md" @click="handlePedigree">{{ $t("generate") }}</b-button>
                </div>
              </b-form>

              <hr>
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingPedigree"
                    :loading="isLoadingPedigree"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Result Empty -->
              <div class="row" v-if="!isLoadingPedigree && isLoadedPedigree && pedigree.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No History were found for this user. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Top list tools -->
              <div class="row mb-3" v-if="!isLoadingPedigree && isLoadedPedigree && pedigree.length > 0">

                <!-- Pagination -->
                <div class="d-flex justify-content-center">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pedigreePage"
                        :total-rows="pedigreeCount"
                        :per-page="100"
                        first-number
                        last-number
                        @change="handlePedigreePage"
                        aria-controls="pedigree-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- Result list -->
              <div v-if="!isLoadingPedigree && isLoadedPedigree && pedigree.length > 0">
                <div class="table-responsive">
                  <table
                      id="pedigree-list"
                      class="table project-list-table table-centered align-middle"
                  >
                    <thead class="table-light">
                      <th scope="col" style="width:150px !important;">Date</th>
                      <th scope="col">Action</th>
                      <th scope="col">Device</th>
                      <th scope="col"></th>
                    </thead>
                    <tbody>
                      <tr v-for="(event, index) in pedigree" :key="index" :style="'background-color:' + event.bgColor + ';'">
                        <td>
                          <small>{{ formatDateTimestamp(event.eventAt, 'DD MMM YYYY HH:mm') }}</small><br>
                          <strong>{{ event.appVersion }}</strong>
                          <span v-if="event.deviceOffset !== ''"><br>{{ event.deviceOffset }}H</span>
                          <!--<span v-if="event.appInstall !== ''"><br>{{ event.appInstall }}</span>-->
                        </td>
                        <td>
                          <span
                              class="badge"
                              :class="{
                                'bg-success text-light': `${event.eventType}` === 'enter',
                                'bg-info text-light': `${event.eventType}` === 'spreedl' ,
                                'bg-danger text-light': `${event.eventType}` === 'app',
                                'bg-light text-dark': `${event.eventType}` === 'other',
                                'bg-pink text-light': `${event.eventType}` === 'spreedl',
                                'bg-pedigree-packets text-light': `${event.eventType}` === 'spreedl packets',
                                'bg-warning text-dark': `${event.eventType}` === 'screen',
                                'bg-dark text-light': `${event.eventType}` === 'notification',
                                'bg-pedigree-email text-light': `${event.eventType}` === 'email',
                                'bg-pedigree-payment text-light': `${event.eventType}` === 'payment',
                              }"
                          >{{ event.eventType }}</span>
                          <p>{{ event.eventName}}</p>
                          <small>{{ event.params }}</small>
                        </td>
                        <td>
                          <span v-if="event.deviceBrand !== ''"><strong>{{ event.deviceBrand }}</strong><br><small>{{ event.deviceModel }}</small></span>
                          <span v-if="event.deviceOS !== ''"><br><small>{{ event.deviceOS }}</small></span>
                          <!--<span v-if="event.deviceAdTrack !== ''"><br><small>Track Disabled: <b>{{ event.deviceAdTrack }}</b></small></span>-->
                        </td>
                        <td>
                          <i class="bx bx-search" @click="handlePedigreeEvent(event.eventRawName)"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row mb-3" v-if="!isLoadingPedigree && isLoadedPedigree && pedigree.length > 0">
                <!-- Pagination -->
                <div class="d-flex justify-content-center">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pedigreePage"
                        :total-rows="pedigreeCount"
                        :per-page="100"
                        first-number
                        last-number
                        @change="handlePedigreePage"
                        aria-controls="pedigree-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </b-tab>
      <!-- Actions -->
      <b-tab v-if="isAdmin">
        <template #title>
          <i class="bx bx-list-ul"></i> Actions
        </template>
        <div>
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary">Actions <b-button v-if="!isLoadingActions" variant="primary" class="w-md" @click="generateActions">{{ $t("generate") }}</b-button></h5>

              <div class="col-sm-auto">

              </div>

              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingActions"
                    :loading="isLoadingActions"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Result Empty -->
              <div class="row" v-if="!isLoadingActions && isLoadedActions && actions.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No History were found for this user. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Top list tools -->
              <div class="row mb-3" v-if="!isLoadingActions && isLoadedActions && actions.length > 0">

                <div style="display: grid; grid-template-columns: auto auto" class="mb-2">
                  <span class="badge bg-success p-2 m-1">{{ actionsStats.matches }} matches Generated</span>
                  <span class="badge bg-pink p-2 m-1" >{{ actionsStats.iceBreakers }} iceBreakers Accepted Generated</span>
                  <span class="badge bg-info p-2 m-1">{{ actionsStats.threads }} threads with replies</span>
                  <span class="badge bg-light p-2 m-1 text-dark">{{ actionsStats.messages }} messages sent from user</span>
                  <span class="badge bg-warning p-2 m-1 text-dark">{{ actionsStats.answers }} replies from operators</span>
                  <span class="badge bg-primary p-2 m-1 text-white">{{ actionsStats.likes }} likes from schedule</span>
                </div>

                <!-- Pagination -->
                <div class="d-flex justify-content-center">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="actionsPage"
                        :total-rows="actionsCount"
                        :per-page="100"
                        first-number
                        last-number
                        @change="handleActionsPage"
                        aria-controls="actions-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- Result list -->
              <div v-if="!isLoadingActions && isLoadedActions && actions.length > 0">
                <div class="table-responsive">
                  <table
                      id="actions-list"
                      class="table project-list-table table-centered align-middle"
                  >
                    <thead class="table-light">
                    <th scope="col">Action</th>
                    <th scope="col">Member</th>
                    <th scope="col">Content</th>
                    </thead>
                    <tbody>
                    <tr v-for="(action, index) in actions" :key="index">
                      <td>
                          <small>{{ formatDateString(action.tps, 'DD MMM YYYY HH:mm') }}</small><br>
                          <span
                              class="badge"
                              :class="{
                                'bg-success text-light': `${action.eventType}` === 'matchGenerated',
                                'bg-info text-light': `${action.eventType}` === 'newThread' ,
                                'bg-light text-dark': `${action.eventType}` === 'messageSent',
                                'bg-pink text-light': `${action.eventType}` === 'iceBreakerAccepted',
                                'bg-warning text-dark': `${action.eventType}` === 'answerMessage',
                                'bg-primary text-light': `${action.eventType}` === 'getLike',
                                'bg-dark text-light': `${action.eventType}` === 'getIceBreaker',
                              }"
                          >{{ action.eventType }}</span>
                      </td>
                      <td>
                        <div class="media" v-show="action.memberId !== null ">
                          <div class="avatar-xs">
                            <img
                                :id="`generator-member-${index}`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                        <span
                            :class="{
                            'text-primary': action.memberSex === 1,
                            'text-danger': action.memberSex === 2,
                            'text-dark': action.memberSex === 0,
                          }"
                        >
                          {{ action.memberName || '-' }}
                        </span> {{ getAge(action.memberBirth) }}</h5>
                            <small class="text-muted">#{{ action.memberId }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        {{ action.messageContent }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row mb-3" v-if="!isLoadingActions && isLoadedActions && actions.length > 0">
                <!-- Pagination -->
                <div class="d-flex justify-content-center">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="actionsPage"
                        :total-rows="actionsCount"
                        :per-page="100"
                        first-number
                        last-number
                        @change="handleActionsPage"
                        aria-controls="actions-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <div class="updateLoading" v-show="isUpdating || !isUserInit">
      <vue-ellipse-progress
          v-show="isUpdating || !isUserInit"
          :loading="true"
          :angle="-90"
          color="#50a5f1"
          emptyColor="#999"
          emptyColorFill="#fff"
          :size="100"
          :thickness="3"
          :emptyThickness="2"
          lineMode="out 2"
          animation="bounce 700 400"
          fontColor="#666"
          :half="false"
          fontSize="1rem">
      </vue-ellipse-progress>
    </div>
  </div>
</template>

<style>
  .bg-pedigree-packets {
    background-color: #ce702d;
  }

  .bg-pedigree-email {
    background-color: #8b2dce;
  }

  .bg-pedigree-payment {
    background-color: #2db6ce;
  }

  .interest-selected {
    font-weight: bold;
  }

  .interest-deselected {
    font-weight: normal;
  }

  .interest-selected i.fas,
  .interest-deselected i.fas {
    color:#666666;
    display: none;
    font-size: 10px;
  }

  .interest-selected:hover i.fas,
  .interest-deselected:hover i.fas {
    display: inline-block;
    margin-left: 2px;
    margin-right: 2px;
  }

  .vue-js-switch {
    font-size: 12px !important;
    text-transform: capitalize;
  }

  .vue-simple-context-menu {
    background: white !important;
    min-width: 120px;
    box-shadow: #000 0 0 10px;
  }

  .vue-simple-context-menu__item span {
    display: block;
    text-transform: uppercase;
    color: #666
  }

  .vue-simple-context-menu__item span:hover {
    color:#fff;
    font-weight: bold;
  }

  .user-primary-info {
    margin-bottom: 5px;
  }

  .user-primary-info > i {
    background-color: #fff;
    width: 22px;
    height: 22px;
  }
  .gallery {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
    grid-gap: 0.5rem;
    /*max-width: 80rem;*/
    margin: 0.5rem auto;
    padding: 0;
  }
  .gallery-panel {
    cursor: pointer;
    border-radius: 0.75rem;
    box-shadow: #ccc 1px 0 10px;
  }
  .gallery-panel .img {
    width: 100%;
    height: 7vw;
    object-fit: cover;
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
  .gallery-number {
    /*color: rgba(255,255,255,0.8);*/
    color: #2a3042;
    font-weight: bold;
    font-size: 18px;
  }
  .gallery-menu {

  }
  .gallery-menu > svg {
    /*box-shadow: #000 1px 0 4px;*/
  }

  .updateLoading {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(255, 255, 255, .7);
    border-radius: 10px;
  }

  .updateLoading > div {
    position: relative;
    width: 100px;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
  }

  .ribbon {
    width: 150px;
    height: 150px;
    overflow: hidden;
    position: absolute;
  }
  .mini-ribbon {
    width: 100px;
    height: 100px;
    overflow: hidden;
    position: absolute;
  }
  .ribbon::before,
  .ribbon::after {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
    border: 5px solid #333;
  }
  .mini-ribbon::before,
  .mini-ribbon::after {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
    border: 2px solid #333;
  }
  .ribbon span {
    position: absolute;
    display: block;
    width: 225px;
    padding: 15px 0;
    background-color: #444;
    box-shadow: 0 5px 10px rgba(0,0,0,.1);
    color: #fff;
    font: 700 18px/1 'Lato', sans-serif;
    text-shadow: 0 1px 1px rgba(0,0,0,.2);
    text-transform: uppercase;
    text-align: center;
  }
  .mini-ribbon span {
    position: absolute;
    display: block;
    width: 150px;
    padding: 7px 0;
    background-color: #f46a6a ;
    box-shadow: 0 5px 10px rgba(0,0,0,.1);
    color: #fff;
    font: 700 13px/1 'Lato', sans-serif;
    text-shadow: 0 1px 1px rgba(0,0,0,.2);
    text-transform: uppercase;
    text-align: center;
  }

  /* top right*/
  .ribbon-top-right {
    top: -10px;
    right: -10px;
  }
  .ribbon-top-right::before,
  .ribbon-top-right::after {
    border-top-color: transparent;
    border-right-color: transparent;
  }
  .ribbon-top-right::before {
    top: 0;
    left: 0;
  }
  .ribbon-top-right::after {
    bottom: 0;
    right: 0;
  }
  .ribbon-top-right span {
    left: -25px;
    top: 29px;
    transform: rotate(45deg);
  }
  .mini-ribbon-top-right {
    top: -3px;
    right: -3px;
  }
  .mini-ribbon-top-right::before,
  .mini-ribbon-top-right::after {
    border-top-color: transparent;
    border-right-color: transparent;
  }
  .mini-ribbon-top-right::before {
    top: 0;
    left: 0;
  }
  .mini-ribbon-top-right::after {
    bottom: 0;
    right: 0;
  }
  .mini-ribbon-top-right span {
    left: -15px;
    top: 19px;
    transform: rotate(45deg);
  }

  /* top left */
  .mini-ribbon-top-left {
    top: -3px;
    left: -3px;
  }
  .mini-ribbon-top-left::before,
  .mini-ribbon-top-left::after {
    border-top-color: transparent;
    border-right-color: transparent;
  }
  .mini-ribbon-top-left::before {
    top: 0;
    right: 0;
  }
  .mini-ribbon-top-left::after {
    bottom: 0;
    left: 0;
  }
  .mini-ribbon-top-left span {
    right: -15px;
    top: 19px;
    transform: rotate(-45deg);
  }

</style>
